module.exports = __webpack_public_path__ + "img/LF002-04.98d40442.jpg";